<template>
  <div class="nb-dashboard-varejo">
    <!-- ATALHOS RÁPIDOS VAREJO / PDV -->
    <div class="nb-varejo-shortcuts mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div class="nb-shortcuts-title">
          <i class="fa fa-shopping-basket text-primary mr-1"></i> Operação de Frente de Caixa &amp; PDV
        </div>
        <div class="d-flex flex-wrap gap-2">
          <button
            type="button"
            class="btn nb-quick-btn"
            @click="clickConsulta('/varejo/novo')"
          >
            <i class="fa fa-desktop text-success mr-1"></i> Frente de Caixa (PDV)
          </button>
          <button
            type="button"
            class="btn nb-quick-btn"
            @click="clickConsulta('/varejo/controlecaixa')"
          >
            <i class="fa fa-calculator text-primary mr-1"></i> Gerenciar Caixas
          </button>
          <button
            type="button"
            class="btn nb-quick-btn"
            @click="clickConsulta('/fvpedidolist')"
          >
            <i class="fa fa-list-alt text-info mr-1"></i> Gerenciar Vendas
          </button>
          <button
            type="button"
            class="btn nb-quick-btn"
            @click="clickConsulta('/consultas/varejo-movimento-caixa')"
          >
            <i class="fa fa-money text-warning mr-1"></i> Movimento de Caixa
          </button>
        </div>
      </div>
    </div>

    <!-- CAIXAS ABERTOS EM TEMPO REAL -->
    <div class="row mb-4" v-if="caixasAbertosList.length">
      <div class="col-12">
        <div class="nb-dash-card p-3">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center">
              <span class="nb-status-dot pulse-green mr-2"></span>
              <span class="font-weight-bold text-dark" style="font-size: 14px;">Caixas em Operação (Abertos)</span>
            </div>
            <span class="badge badge-info-soft">{{ caixasAbertosList.length }} terminal(is) ativo(s)</span>
          </div>

          <div class="row">
            <div
              class="col-xl-3 col-md-6 col-12 mb-2"
              v-for="(caixa, index) in caixasAbertosList"
              :key="index"
            >
              <div class="nb-register-box p-3">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <span class="register-operator">
                    <i class="fa fa-user-circle-o mr-1"></i> {{ caixa.operador || 'Operador' }}
                  </span>
                  <span class="badge badge-success-soft">Aberto</span>
                </div>
                <div class="register-lbl">Total em Vendas</div>
                <div class="register-val">R$ {{ caixa.totalvendas | formatValue(2) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- INDICADORES PRINCIPAIS DE VAREJO -->
    <div class="row mb-4">
      <dash-card :params="dashboard.items[0]" :filter="filter"></dash-card>
    </div>

    <!-- GRÁFICO E TABELA DE FORMAS DE PAGAMENTO -->
    <div class="row">
      <dash-card :params="dashboard.items[1]" :filter="filter"></dash-card>

      <div class="col-md-8 col-12 mb-4">
        <div class="nb-dash-card">
          <div class="nb-dash-header">
            <span class="nb-dash-title-text">
              <i class="fa fa-credit-card mr-2 text-primary"></i> Vendas por Forma de Pagamento
            </span>
            <span class="nb-badge-sub" v-if="totalFormas > 0">
              Total: R$ {{ totalFormas | formatValue(2) }}
            </span>
          </div>

          <div class="p-3" style="max-height: 340px; overflow-y: auto;">
            <table class="table table-hover nb-table mb-0">
              <thead>
                <tr>
                  <th>Forma de Pagamento</th>
                  <th class="text-right" style="width: 140px;">Valor (R$)</th>
                  <th class="text-right" style="width: 120px;">% Percentual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in formasList" :key="index">
                  <td class="font-weight-medium">
                    <i class="fa fa-circle mr-2" :style="{ color: getFormaColor(index) }"></i>
                    {{ row.descricao }}
                  </td>
                  <td class="text-right font-weight-bold text-dark">
                    R$ {{ row.valor | formatValue(2) }}
                  </td>
                  <td class="text-right">
                    <span class="badge badge-perc">{{ row.perc | formatValue(2) }}%</span>
                  </td>
                </tr>
                <tr v-if="formasList.length === 0">
                  <td colspan="3" class="text-center text-muted py-4">
                    Nenhuma venda registrada no período selecionado.
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="formasList.length > 0">
                <tr class="nb-table-total-row">
                  <th>Total Geral</th>
                  <th class="text-right">R$ {{ totalFormas | formatValue(2) }}</th>
                  <th class="text-right">100,00%</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from './dash-card'
import { apiORDS, apiORDSpost } from '../shared/api-functions'
import { formatValue } from '../shared/utils'
import DashboardGuiaNfe from './dashboard-guia-nfe.vue'
import { SysVars } from '../main'

export default {
  name: 'dashboard-varejo',

  components: {
    DashCard,
    DashboardGuiaNfe
  },

  props: {
    filterProp: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      filter: {
        startDate: null,
        endDate: null,
        codusuario: null,
      },

      dashboard: {
        items: [
          { name: 'varejoindicadorvendas', indicator: {}, col: 12 },
          { name: 'varejograficoformas', chart: { type: 'PieChart' }, col: 4 },
        ]
      },

      caixasList: [],
      formasList: [],
    }
  },

  watch: {
    filterProp: {
      handler(val) {
        if (val) {
          this.filter.startDate = val.startDate
          this.filter.endDate = val.endDate
          this.filter.codusuario = val.codusuario
          this.loadData()
        }
      },
      deep: true,
      immediate: true
    },
  },

  computed: {
    sessao: function () {
      return this.$store.getters.getSessao
    },

    caixasAbertosList: function () {
      return (this.caixasList || []).filter(caixa => caixa.aberto)
    },

    totalFormas: function () {
      return this.formasList.reduce((acc, row) => acc + (parseFloat(row.valor) || 0), 0)
    }
  },

  methods: {
    getFormaColor(index) {
      const colors = ['#004e94', '#10b981', '#0ea5e9', '#f59e0b', '#8b5cf6', '#ef4444', '#64748b']
      return colors[index % colors.length]
    },

    updateQuery() {
      this.$router.replace({ query: { data_inicio: this.filter.startDate, data_termino: this.filter.endDate } })
    },

    clickConsulta(url) {
      this.$router.push(url)
    },

    handleMonthChange() {
      this.updateQuery()
    },

    async loadData() {
      let filtro = {
        data_inicio: this.filter.startDate,
        data_termino: this.filter.endDate,
      }

      // Caixas abertos
      let param = { query: 'status=0' }
      const data2 = await apiORDS(this.$store.getters.urlOrds + 'varejo/controlecaixa/list', param)
      if (data2 && data2.items)
        this.caixasList = data2.items

      // Resumo de formas de pagamento
      const data3 = await apiORDSpost(this.$store, 'consulta/vendas/varejoresumoformas', filtro, 'post')
      if (data3 && data3.items)
        this.formasList = data3.items
    },
  },

  filters: {
    formatValue(val, dec) {
      return formatValue(val, dec || 2)
    }
  },

  mounted() {
    this.loadData()
  },

  created() {
    if (!this.filterProp && this.$route.query.data_inicio) {
      this.filter.startDate = this.$firstDay(this.$route.query.data_inicio)
      this.filter.endDate = this.$lastDay(this.$route.query.data_termino)
    }
  }
}
</script>

<style scoped>
.nb-dashboard-varejo {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.nb-dash-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.nb-dash-header {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nb-dash-title-text {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #0b1c30;
}

.nb-badge-sub {
  font-size: 11.5px;
  font-weight: 700;
  color: #004e94;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  padding: 3px 9px;
  border-radius: 20px;
}

/* SHORTCUTS */
.nb-varejo-shortcuts {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.nb-shortcuts-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #64748b;
}

.nb-quick-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #1e293b;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.nb-quick-btn:hover {
  background: #eff4ff;
  border-color: #9ac1ff;
  color: #004e94;
  transform: translateY(-1px);
}

/* CAIXAS ABERTOS */
.nb-register-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  border-left: 3px solid #10b981;
}

.register-operator {
  font-size: 12px;
  font-weight: 700;
  color: #0b1c30;
}

.register-lbl {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  font-weight: 600;
}

.register-val {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #004e94;
}

.nb-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #10b981;
}

.pulse-green {
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  animation: pulseGreen 2s infinite;
}

@keyframes pulseGreen {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

.badge-success-soft {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 6px;
}

.badge-info-soft {
  background: #eff4ff;
  color: #004e94;
  border: 1px solid #dce9ff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
}

.badge-perc {
  background: #f1f5f9;
  color: #334155;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 4px;
}

/* TABLE */
.nb-table th {
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #64748b;
  border-top: none;
  background: #f8fafc;
}

.nb-table td {
  font-size: 13px;
  vertical-align: middle;
}

.nb-table-total-row th {
  background: #eff4ff;
  color: #004e94;
  font-size: 13px;
  font-weight: 700;
  border-top: 2px solid #9ac1ff;
}
</style>








// WEBPACK FOOTER //
// src/dashboards/dashboard-varejo.vue